import React from 'react';
import AdminSidebar from '../components/sidebar/AdminSidebar';
import Header from '../components/Header';

/**
 * AdminLayout Component
 *
 * Main layout wrapper for authenticated admin pages.
 * Includes sidebar navigation, header and content area.
 */
interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className="flex h-screen w-full overflow-hidden">
      {/* @ts-ignore */}
      <AdminSidebar />
      <div className="flex-1 flex flex-col overflow-y-auto">
        <Header />
        {children}
      </div>
    </div>
  );
};

export default AdminLayout;
